if (!customElements.get('product-contact-actions')) {
  class ProductContactActions extends HTMLElement {
    connectedCallback() {
      this.inline = this.querySelector('.pca-inline');
      this.sticky = this.querySelector('[data-pca-sticky]');
      this.modals = Array.from(
        document.querySelectorAll(
          `dialog[data-pca-modal^="ask-"], dialog[data-pca-modal^="reserve-"]`,
        ),
      ).filter((modal) => this.contains(modal));

      this.stickyDismissed = false;

      // Move the fixed bottom bar to <body>. A `position: sticky` ancestor
      // (the sticky info column) traps fixed-position descendants inside
      // its own stacking context in most browsers, which makes later page
      // sections (e.g. recommendations) paint over the bar instead of
      // under it. Re-parenting avoids that trap entirely.
      if (this.sticky && this.sticky.parentElement !== document.body) {
        document.body.appendChild(this.sticky);
      }

      this.setupStickyObserver();
      this.setupStickyClose();
      this.setupModalTriggers();
    }

    setupStickyObserver() {
      if (!this.inline || !this.sticky) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.stickyDismissed = false;
              this.sticky.classList.remove('is-visible');
              this.sticky.setAttribute('hidden', '');
            } else if (!this.stickyDismissed) {
              this.sticky.removeAttribute('hidden');
              requestAnimationFrame(() => {
                this.sticky.classList.add('is-visible');
              });
            }
          });
        },
        { threshold: 0 },
      );

      observer.observe(this.inline);
    }

    setupStickyClose() {
      if (!this.sticky) return;
      const closeBtn = this.sticky.querySelector('[data-pca-sticky-close]');
      if (!closeBtn) return;

      closeBtn.addEventListener('click', () => {
        this.stickyDismissed = true;
        this.sticky.classList.remove('is-visible');
        this.sticky.setAttribute('hidden', '');
      });
    }

    setupModalTriggers() {
      const triggers = this.querySelectorAll('[data-pca-open]');
      const stickyTriggers = this.sticky ? this.sticky.querySelectorAll('[data-pca-open]') : [];

      [...triggers, ...stickyTriggers].forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const key = trigger.getAttribute('data-pca-open');
          const modal = this.querySelector(`dialog[data-pca-modal="${key}"]`);
          if (modal && typeof modal.showModal === 'function') {
            modal.showModal();
          }
        });
      });

      this.modals.forEach((modal) => {
        modal.querySelectorAll('[data-pca-close]').forEach((closeBtn) => {
          closeBtn.addEventListener('click', () => modal.close());
        });

        modal.addEventListener('click', (event) => {
          if (event.target === modal) {
            modal.close();
          }
        });
      });
    }
  }

  customElements.define('product-contact-actions', ProductContactActions);
}
